export const translations = {
  stock: {
    pt: 'Gestão de Estoques',
    en: 'Inventory Management',
    de: 'Bestandsverwaltung',
    es: 'Gestión de Inventario',
  },
  back: {
    pt: 'Voltar',
    en: 'To go Back',
    de: 'Zurückgehen',
    es: 'Para Volver',
  },
};
